<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded01">
<p class="dedicationText"><span class="bold"><em class="italic">To the memory of my mother,<br/>
Jeanette S. M. Jones</em></span></p>
<a id="page10"> </a><a id="page11"></a></div><a id="page11">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061748714_dedication.vue?2f2d36a4